// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"888ff23a","154":"1607a238","533":"af63462e"}[chunkId] + ".chunk.css";
};